import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaUserMd, FaHeart, FaLaptopMedical, FaStar } from "react-icons/fa";
import { motion } from "framer-motion";
import "./WhyChooseUs.css";

function WhyChooseUs() {
  const features = [
    {
      icon: <FaUserMd size={40} />,
      title: "Personalized Care",
      desc: "We tailor treatments to your unique skin and hair needs, ensuring the best possible outcomes."
    },
    {
      icon: <FaHeart size={40} />,
      title: "Holistic Approach",
      desc: "We focus on treating the individual, not just the symptoms, for comprehensive and lasting improvements."
    },
    {
      icon: <FaLaptopMedical size={40} />,
      title: "Cutting-edge Technology",
      desc: "We use state-of-the-art technologies and research-backed treatments for safe, effective results."
    },
    {
      icon: <FaStar size={40} />,
      title: "Commitment to Quality",
      desc: "We deliver the highest quality of care with no compromises, ensuring patient satisfaction."
    }
  ];

  return (
    <Container fluid className="my-5 px-0 overflow-hidden">
      <Row className="align-items-stretch g-0 flex-column flex-md-row">
        {/* Left Column with Animated Background + Text */}
        <Col md={6} className="d-flex">
          <motion.div
            initial={{ x: "-30%", opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0 }}
            className="why-left-content h-100 w-100 d-flex flex-column justify-content-center text-white position-relative"
            style={{
              backgroundImage: "url('/burnt-org-background.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            {/* Transparent Overlay */}
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1
              }}
            ></div>

            {/* Text Content */}
            <div style={{ position: "relative", zIndex: 2 }}>
              <span className=" text-uppercase mb-2">
            Best Skin clinic in Pimpri Chinchwad
          </span>
              <h2 style={{}} className="mb-2 fw-bold text-center text-md-start text-uppercase">
                Why Choose Us ?
              </h2>
              <p className="mb-5" style={{ fontSize: "1rem" }}>
            Experience exceptional care and expertise with Dr. Trupti Hambire.
          </p>
              {features.map((item, idx) => (
                <div
                  key={idx}
                  className="why-feature d-flex flex-column flex-sm-row text-center text-sm-start"
                >
                  <div className="icon-box me-sm-3 mb-2 mb-sm-0 d-flex justify-content-center">
                    {item.icon}
                  </div>
                  <div>
                    <h5 className="mb-2 text-uppercase">{item.title}</h5>
                    <p className="mb-0">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </Col>

        {/* Right Column */}
        <Col md={6} className="d-flex">
          <motion.div
            initial={{ x: "30%", opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0 }}
            className="h-100 w-100"
          >
            <img
              src="/drTruptis-clinic-s.jpg"
              alt="Why Choose Us"
              className="img-fluid w-100 h-100"
              style={{ objectFit: "cover" }}
            />
          </motion.div>
        </Col>
      </Row>
    </Container>
  );
}

export default WhyChooseUs;
